import { render, staticRenderFns } from "./BillDetail.vue?vue&type=template&id=1fa73db6&scoped=true"
import script from "./BillDetail.vue?vue&type=script&lang=js"
export * from "./BillDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa73db6",
  null
  
)

export default component.exports